import { Network } from '../enums';

export const SocialNetworks: Network[] = [Network.YOUTUBE];
